<mat-card class="card">
  <mat-card-content>
    <h1>Praxis Registrierung</h1>
    <form [formGroup]="form" class="form">
      <mat-form-field class="input-section">
        <mat-label>Email</mat-label>
        <input type="email" matInput formControlName="email" placeholder="Ex. pat@example.com" autocomplete="email" />
        @if (form.controls.email.hasError('email') && !form.controls.email.hasError('required')) {
          <mat-error>Please enter a valid email address</mat-error>
        }
        @if (form.controls.email.hasError('required')) {
          <mat-error>Email is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      <mat-form-field class="input-section">
        <mat-label>Password</mat-label>
        <input type="password" matInput formControlName="password" autocomplete="one-time-code" />
        @if (!form.controls.password.hasError('required')) {
          <mat-error>Please enter a password</mat-error>
        }
        @if (form.controls.password.hasError('required')) {
          <mat-error>Password is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      <mat-form-field class="input-section">
        <mat-label>Praxis Name</mat-label>
        <input type="text" matInput formControlName="officeName" placeholder="Name der Praxis" />
      </mat-form-field>
      <mat-form-field class="input-section">
        <mat-label>Praxis Kontaktdaten</mat-label>
        <textarea type="text" matInput formControlName="contactData" placeholder="Kontaktdaten der Praxis"></textarea>
      </mat-form-field>

      @if ($authError() !== '') {
        <mat-error>{{ $authError() }}</mat-error>
      }
    </form>

    <div class="buttons">
      <button routerLink="../auth" mat-button>zum Login</button>
      <button mat-raised-button (click)="onSignup()">Neu registrieren</button>
    </div>
  </mat-card-content>
</mat-card>
